
/**
 * 麻将
 */
export namespace MahjongKind {

    export enum GeneralValue {
        /** 海底捞概率 */
        HAI_DI_LAO_PROB = 0.05,
    }

    /** 牌型 */
    export enum CardType {
        /** 对对胡 */
        DUI_DUI_HU = 1, 
        /** 七对 */
        QI_DUI, 
        /** 清一色 */
        QING_YI_SE, 
        /** 豪七对 */
        HAO_QI_DUI, 
        /** 清七对 */
        QING_QI_DUI, 
        /** 碰清 */
        PENG_QING, 
        /** 清豪七对 */
        QING_HAO_QI_DUI, 
        /** 十三幺 */
        SHI_SAN_YAO, 
        /** 九连宝灯 */
        JIU_LIAN_BAO_DENG, 
        /** 海底捞 */
        HAI_DI_LAO, 
    }

    /** 牌型信息 */
    class CardTypeInfo {
        /** 倍数 */
        multipe: number = 0;
        /** 名称 */
        name: string = '';
    }

    /** 牌型信息 */
    export const CardTypeInfoArr = {
        /** 对对胡 */
        [CardType.DUI_DUI_HU]: {
            multipe: 6
            , name: '对对胡'
        }, 
        /** 七对 */
        [CardType.QI_DUI]: {
            multipe: 6
            , name: '七对'
        },
        /** 清一色 */
        [CardType.QING_YI_SE]: {
            multipe: 6
            , name: '清一色'
        },
        /** 豪七对 */
        [CardType.HAO_QI_DUI]: {
            multipe: 12
            , name: '豪七对'
        },
        /** 清七对 */
        [CardType.QING_QI_DUI]: {
            multipe: 12
            , name: '清七对'
        },
        /** 碰清 */
        [CardType.PENG_QING]: {
            multipe: 12
            , name: '碰清'
        },
        /** 清豪七对 */
        [CardType.QING_HAO_QI_DUI]: {
            multipe: 36
            , name: '清豪七对'
        },
        /** 十三幺 */
        [CardType.SHI_SAN_YAO]: {
            multipe: 36
            , name: '十三幺'
        },
        /** 九莲宝灯 */
        [CardType.JIU_LIAN_BAO_DENG]: {
            multipe: 36
            , name: '九莲宝灯'
        },
        /** 海底捞月 */
        [CardType.HAI_DI_LAO]: {
            multipe: 5
            , name: '海底捞月'
        },
    }

    /** 牌型概率信息 */
    class CardTypeProbInfo {
        /** 概率 */
        prob: number = 0;
        /** 包含的牌型 */
        cardType: number[] = [];
    }

    /** 牌型概率 */
    export const CardTypeProb: CardTypeProbInfo[] = [
        // 6倍
        {
            prob: 0.5
            , cardType: [
                CardType.DUI_DUI_HU
                , CardType.QI_DUI
                , CardType.QING_YI_SE
            ]
        },
        // 12倍
        {
            prob: 0.3
            , cardType: [
                CardType.HAO_QI_DUI
                , CardType.QING_QI_DUI
                , CardType.PENG_QING
            ]
        },
        // 36倍
        {
            prob: 0.2
            , cardType: [
                CardType.QING_HAO_QI_DUI
                , CardType.SHI_SAN_YAO
                , CardType.JIU_LIAN_BAO_DENG
            ]
        },
    ];

    /** 中奖概率信息 */
    class WinProbInfo {
        /** 概率 */
        prob: number = 0;
        /** 金额 */
        sum: number = 0;
    }

    /** 中奖概率 */
    export const WinProb: WinProbInfo[] = [
        {
            prob: 0.2
            , sum: 0
        },
        {
            prob: 0.2
            , sum: 1000
        },
        {
            prob: 0.2
            , sum: 3000
        },
        {
            prob: 0.15
            , sum: 8000
        },
        {
            prob: 0.1
            , sum: 28000
        },
        {
            prob: 0.1
            , sum: 66000
        },
        {
            prob: 0.05
            , sum: 100000
        },
    ];

    /** 牌型数据 */
    export class CardTypeData {
        /** 牌 */
        card: number[] = [];
        /** 能胡的牌 */
        winCard: number[] = [];
    }

}

